import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { CreditCardAccountDetailsView } from '@webapp/modules/accounts-payable/feature-sets/CreditCardAccountDetailsView'
import { useCreditCardStatementDetailsPresenter } from '@webapp/modules/accounts-payable/features/get-credit-card-account/presenters/CreditCardStatementDetailsPresenter'
import messages from './messages'
import { type CreditCardAccountDetailsPageParams } from './types'

export const CreditCardAccountDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { id, tab } = useParams<CreditCardAccountDetailsPageParams>()

  const accountId = Number(id)

  // Presenter companion hook (hook-data only) supplies the account name for
  // the page title + trailing crumb; React Query dedupes with the Feature
  // Set's calls (Sibling Pages pattern).
  const { account } = useCreditCardStatementDetailsPresenter({ accountId })

  return (
    <Page
      pageTitle={
        account?.name ??
        intl.formatMessage(messages.creditCardReconciliationPageTitle)
      }
      breadcrumbs={
        account
          ? [
              {
                link: url('CreditCardReconciliationPage'),
                name: intl.formatMessage(
                  messages.creditCardReconciliationPageTitle
                ),
              },
              { name: account.name },
            ]
          : [
              {
                name: intl.formatMessage(
                  messages.creditCardReconciliationPageTitle
                ),
              },
            ]
      }
    >
      <CreditCardAccountDetailsView accountId={accountId} tab={tab} />
    </Page>
  )
}
